<template>
    <div>
        <div class="generator">
            <button @click="generate()">ビンゴを回す</button>
        </div>
        <div v-if="this.$store.getters.bingoNum !== null">
            <div v-for="(value,key) in this.$store.getters.bingoNum" v-bind:key="key">
                <span class="title">{{(bingo_length-key)+"回目 "+value}}</span>
            </div>
        </div>
        <div v-else>数値なし</div>
    </div>
</template>

<script>
    /* eslint-disable no-console */
    import firebase from 'firebase'

    export default {
        name: "BingoGenerator",
        data() {
            return {
                bingo_length: null
            }
        },
        methods: {
            generate: function () {
                if (confirm("ビンゴを回していいですか?")) {
                    var num = this.calculation()
                    firebase.database().ref('/bingo').push(num)
                    this.bingo_length = this.$store.getters.bingoNum.length
                }
            },
            calculation: function () {
                var arr = this.$store.getters.bingoNum
                var num = Math.floor(Math.random() * 75) + 1
                console.log(num)
                if (arr !== null && arr.length >= 75) return 9999
                while (arr !== null) {
                    if (arr.every(function (value) {
                        return value !== num
                    })) break
                    num = Math.floor(Math.random() * 75) + 1
                }
                return num
            }
        },
        created: function () {
            var arr = this.$store.getters.bingoNum
            if (arr !== null) {
                this.bingo_length = arr.length
            } else {
                this.bingo_length = 0
            }
        }
    }
</script>

<style scoped>

</style>